import { SkeletonLoader } from "@via/components/loading/loading.tsx";
import { useAuth } from "@via/hooks/useAuth";
import LegacyIframe from "@via/pages/projects/legacy-iframe";
import { useGlobal } from "@via/hooks/useGlobal.tsx";
import { useProjectList } from "@via/pages/projects/projects.api.tsx";
import { type JSX, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function Portal(): JSX.Element {
  const { config } = useAuth();
  const { projectId = "" } = useParams();
  const { selectedProject } = useGlobal();
  const [vPortalUrl, setVPortalUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const { data: projectListData, isSuccess: isProjectListSuccess } =
    useProjectList();

  useEffect(() => {
    if (projectListData && projectId) {
      const slug = "vproject";
      setVPortalUrl(`/vportal/${slug}/${selectedProject?.vmetaId}`);
      setIsLoading(false);
    }

    if (!config.ENABLE_VPORTAL) {
      navigate(`/projects/${projectId}`);
    }
  }, [isProjectListSuccess, config, projectId, selectedProject?.vmetaId]);

  return (
    <main className="py-2">
      {isLoading || !config.ENABLE_VPORTAL ? (
        <div className="grid grid-cols-1 gap-6 py-6 sm:grid-cols-2 lg:grid-cols-3">
          <SkeletonLoader count={12} />
        </div>
      ) : (
        <LegacyIframe src={vPortalUrl} prefix="/vportal" />
      )}
    </main>
  );
}
